import React, { useState, useEffect } from "react";
import { useLoading } from "../../../../context/LoadingContext";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import { jwtDecode } from "jwt-decode";
import { Modal, Button } from "react-bootstrap";
import config from "../../../../aws-exports";
import { getParameterFromManager } from "../../../../services/Utils";

const GPOffersOld = () => {
  const [menuActiveTab, setMenuActiveTab] = useState("All Offers");
  const [activeTab, setActiveTab] = useState("basicInfo");
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const tabs = ["All Offers", "Shortlisted Offers", "Queried Offers", "BAFO"];
  const location = useLocation();
  const [queryDescription, setQueryDescription] = useState("");
  const initialFilter = location.state?.selectedFilter || "All Offers";
  const [selectedFilter, setSelectedFilter] = useState("All Offers"); // Use initialFilter
  const [activeUser, setActiveUser] = useState("");
  const [gpOffers, setGPOffers] = useState([]);
  const [queries, setQueries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [queryPage, setQueryPage] = useState(1);
  const [queryTotalPages, setQueryTotalPages] = useState(1);
  const [selectedGPOffer, setSelectedGPOffer] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [products, setProducts] = useState([]);
  const [states, setStates] = useState([]);
  const [filterTerms, setFilterTerms] = useState({
    product: "",
    grade: "",
    IsShortlist: 0,
    IsBAFO: 0,
  });
  const [showModal, setShowModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [showRaiseQueryModal, setShowRaiseQueryModal] = useState(false);
  const [showSelectBuyerModal, setShowSelectBuyerModal] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState("");
  const [buyers, setBuyers] = useState([]);
  const [isMarginChanged, setIsMarginChanged] = useState(false);
  const [marginPercentage, setMarginPercentage] = useState("");
  const pageSize = 10;
  const queryPageSize = 5;
  const [INRToUsd, setINRToUSD] = useState(0.012);

  const getBackendName = () => {
    const backend = config.aws_user_files_s3_bucket.split("-");
    return backend[backend.length - 1];
  };

  const fetchBuyers = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "listAMTPLUsers",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: { GPEmailID: user.attributes.email },
        rowStart: 0,
        pageSize: 100,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setBuyers(result.items);
      } else {
        console.error("Error fetching buyers: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listProducts",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setProducts(result.items);
      } else {
        console.error("Error fetching products: ", result);
      }
    } catch (error) {
      console.error("Error fetching products", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStates = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });

      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      const backendName = getBackendName();

      const command = new InvokeCommand({
        FunctionName: `dataops-${backendName}`,
        Payload: JSON.stringify({
          body: {
            target: "listDynamicDropDownOptions",
            option: "gpofferitemstates",
            access_token: token,
            rowStart: 0,
            pageSize: 100,
          },
        }),
      });

      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setStates(result.items.map((option) => option.result));
      } else {
        console.error(`Error fetching $States : ${JSON.stringify(result)}`);
      }
    } catch (error) {
      console.error(`Error fetching States: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchGPOffers = async () => {
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });

      const body = {
        target: "listGPOfferDetails",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms,
        userOrder: "CreatedAt DESC",
        rowStart: (currentPage - 1) * pageSize,
        pageSize: pageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setGPOffers(result.items);
        setTotalPages(Math.ceil(result.total / pageSize));
        if (result.items.length > 0) {
          setSelectedGPOffer(result.items[0]);
          const calculatedMargin = calculateMarginPercentage(result.items[0]);
          setMarginPercentage(calculatedMargin); // Set initial margin value
        }
      } else {
        console.error("Error fetching gpOffers: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchQueries = async () => {
    if (!selectedGPOffer) {
      console.error("No client selected");
      return;
    }
    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "listAmtplQueries",
        access_token: user.signInUserSession.idToken.jwtToken,
        filterTerms: { GPOfferId: selectedGPOffer.GPOfferID },
        rowStart: (queryPage - 1) * queryPageSize,
        pageSize: queryPageSize,
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));
      if (result.statusCode === 200) {
        result = JSON.parse(result.body);
        setQueries(result.items);
        setQueryTotalPages(Math.ceil(result.total / queryPageSize));
        if (result.items.length > 0) {
          setSelectedQuery(result.items[0]);
        }
      } else {
        console.error("Error fetching queries: ", result);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateQuery = async () => {
    if (!queryDescription) {
      console.error("Query Description is required");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      const body = {
        target: "createAmtplQuery",
        access_token: user.signInUserSession.idToken.jwtToken,
        createAmtplQueryInput: {
          GPOfferID: selectedGPOffer.GPOfferID, // Assuming this is the selected product
          QueryDescription: queryDescription,
          GPEmailID: user.attributes.email,
          QueryType: "GlobalPartner",
        },
      };

      const params = {
        FunctionName: `dataops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log("Query creation successful", result);
        setShowModalMsg("Query creation successful");
        setShowModal(true);
        // Fetch the updated queries
        fetchQueries();
      } else {
        console.error("Error creating query: ", result);
        setShowModalMsg("Error creating query");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error invoking Lambda function: ", error);
      setShowModalMsg("Error creating query");
      setShowModal(true);
    } finally {
      setLoading(false);
      setShowRaiseQueryModal(false); // Close the modal after handling the query creation
      setQueryDescription(""); // Clear the query description
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        // Check if the user is a member of the AMTPL_BUYERS group
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut(); // Sign out the user
          navigate("/login/global-partner");
        } else {
          setActiveUser(user.attributes.email); // Set the active user email
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut(); // Sign out the user
        navigate("/login/global-partner");
      }
    };

    checkUser();
    fetchGPOffers();
    fetchProducts();
    fetchStates();
    console.log("selectedFilter##", selectedFilter);
    if (activeTab === "queries") {
      fetchQueries();
    }
  }, [
    navigate,
    currentPage,
    queryPage,
    setLoading,
    filterTerms,
    selectedFilter,
  ]);

  useEffect(() => {
    if (activeTab === "queries") {
      fetchQueries();
    }
  }, [selectedGPOffer]);

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await Auth.signOut();
      navigate("/login/global-partner");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMenuTabClick = (tab) => {
    setMenuActiveTab(tab);
    // setSelectedFilter(tab);
    handleDataFilterChange(tab);
    console.log("tab::", tab);
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    console.log("tab::", tab);
    if (tab === "queries") {
      fetchQueries();
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleQueryPageChange = (newPage) => {
    if (newPage > 0 && newPage <= queryTotalPages) {
      setQueryPage(newPage);
    }
  };

  const handleRowClick = (product) => {
    setSelectedGPOffer(product);
    const calculatedMargin = calculateMarginPercentage(product);
    setMarginPercentage(calculatedMargin); // Reset margin value when selecting a new product
    setIsMarginChanged(false); // Reset margin change state when selecting a new product
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterTerms((prevTerms) => ({ ...prevTerms, [name]: value }));
    resetFilter();
  };

  const handleSearch = () => {
    resetFilter();
  };

  const handleReset = () => {
    setFilterTerms({ product: "", grade: "", IsShortlist: 0, IsBAFO: 0 });
    const selectedValue = selectedFilter;
    if (selectedValue === "All Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: 0,
        IsQueried: "",
        IsBAFO: 0,
      }));
    } else if (selectedValue === "Shortlisted Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: 1,
        IsQueried: "",
        IsBAFO: "",
      }));
    } else if (selectedValue === "Queried Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: 1,
        IsBAFO: "",
      }));
    } else if (selectedValue === "BAFO") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: "",
        IsBAFO: 1,
      }));
    }
    resetFilter();
  };

  const handleQueryRowClick = (query) => {
    setSelectedQuery(query);
  };

  const handleAction = async (status) => {
    if (!selectedGPOffer) {
      console.error("No client selected");
      return;
    }

    setLoading(true);
    try {
      const credentials = await Auth.currentCredentials();
      const lambdaClient = new LambdaClient({
        credentials: Auth.essentialCredentials(credentials),
        region: config.aws_project_region,
      });
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });

      let target;
      if (status === "Shortlist") {
        target = "gpShortlistOffer";
      } else if (status === "Modify") {
        target = "gpModifyOffer";
      } else if (status === "BAFO") {
        target = "gpSendBAFO";
      } else if (status === "Approve") {
        target = "gpApproveOffer";
      } else {
        console.error("Invalid status");
        setLoading(false);
        return;
      }

      let body;
      if (status === "Approve") {
        body = {
          target: target,
          access_token: user.signInUserSession.idToken.jwtToken,
          BuyerItemInput: {
            GPOfferID: selectedGPOffer.GPOfferID,
            GPEmailID: user.attributes.email,
            Margin: selectedGPOffer.Margin,
            ProductID: selectedGPOffer.ProductID,
          },
        };
      } else {
        body = {
          target: target,
          access_token: user.signInUserSession.idToken.jwtToken,
          GPOfferExtendedInput: {
            GPOfferID: selectedGPOffer.GPOfferID,
            OfferStatus: status,
            GPEmailID: user.attributes.email,
            Margin: selectedGPOffer.Margin,
          },
        };
        if (status === "Modify") {
          body.GPOfferExtendedInput.Margin =
            (selectedGPOffer.BasePrice * marginPercentage) / 100;
        }
        if (status === "BAFO") {
          body.BuyerItemInput = {
            GPOfferID: selectedGPOffer.GPOfferID,
            Margin: selectedGPOffer.Margin,
            BuyerEmailID: selectedBuyer,
            ProductID: selectedGPOffer.ProductID,
          };
        }
      }

      const params = {
        FunctionName: `backendops-${getBackendName()}`,
        Payload: JSON.stringify({ body }),
      };

      const command = new InvokeCommand(params);
      const data = await lambdaClient.send(command);
      let result = JSON.parse(new TextDecoder("utf-8").decode(data.Payload));

      if (result.statusCode === 200) {
        console.log(`${status} action successful`, result);
        setShowModalMsg(`${status} action successful`);
        setShowModal(true);
        if (status === "Modify") {
          setIsMarginChanged(false); // Reset margin change state after modifying
          const index = gpOffers.findIndex(
            (gpOffer) => gpOffer.GPOfferID === selectedGPOffer.GPOfferID
          );
          // If the gpOffer is found, create a new array with the updated gpOffer
          if (index !== -1) {
            const updatedGPOffers = [...gpOffers];
            updatedGPOffers[index] = {
              ...updatedGPOffers[index],
              Margin: marginPercentage / 100,
            };
            // Update the state with the new array
            setGPOffers(updatedGPOffers);
          }
        }
      } else {
        console.error(`Error updating GPOffer ${JSON.stringify(result)}`);
        setShowModalMsg(`Error updating GPOffer ${JSON.stringify(result)}`);
        setShowModal(true);
      }
    } catch (error) {
      console.error(`Error updating GPOffer ${JSON.stringify(error)}`);
      setShowModalMsg(`Error updating GPOffer ${JSON.stringify(error)}`);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleShortlist = () => handleAction("Shortlist");

  const handleModify = () => handleAction("Modify");

  const handleApprove = () => handleAction("Approve");

  const handleSendBAFO = async () => {
    await fetchBuyers();
    setShowSelectBuyerModal(true);
  };

  const handleSelectBuyer = async () => {
    if (selectedBuyer !== "") {
      await handleAction("BAFO");
    }
    setShowSelectBuyerModal(false);
    setSelectedBuyer("");
  };

  const resetFilter = () => {
    setSelectedGPOffer(null);
    setCurrentPage(1);
    setSelectedQuery(null);
    setQueryPage(1);
    setQueries([]);
  };

  const handleDataFilterChange = (tab) => {
    // console.log(event);
    const selectedValue = tab;
    setSelectedFilter(selectedValue);
    if (selectedValue === "All Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: 0,
        IsQueried: "",
        IsBAFO: 0,
      }));
      resetFilter();
    } else if (selectedValue === "Shortlisted Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: 1,
        IsQueried: "",
        IsBAFO: "",
      }));
      resetFilter();
    } else if (selectedValue === "Queried Offers") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: 1,
        IsBAFO: "",
      }));
      resetFilter();
    } else if (selectedValue === "BAFO") {
      setFilterTerms((prevTerms) => ({
        ...prevTerms,
        IsShortlist: "",
        IsQueried: "",
        IsBAFO: 1,
      }));
      resetFilter();
    } else if (selectedValue === "Requirement") {
      redirectRequirement();
    }
  };

  function formatData(data) {
    if (typeof data === "string" && isNaN(data))
      return parseFloat(data).toFixed(2);
    return data.toFixed(2);
  }

  // Calculate margin percentage from offer data
  const calculateMarginPercentage = (offer) => {
    return offer.Margin && offer.BasePrice
      ? Math.round(((offer.Margin * 100) / offer.BasePrice) * 100) / 100
      : offer.MarginPercentage;
  };

  // Calculate runtime pricing values
  const calculatePricingValues = () => {
    if (!selectedGPOffer)
      return { FOBSalePrice: 0, ExportDuty: 0, CIFSalePrice: 0 };

    const margin = (selectedGPOffer.BasePrice * marginPercentage) / 100;
    const FOBSalePrice = selectedGPOffer.BasePrice + margin;
    const ExportDuty =
      (FOBSalePrice * selectedGPOffer.ExportDutyPercentage) / 100;
    const CIFSalePrice =
      FOBSalePrice +
      ExportDuty +
      selectedGPOffer.ShippingInsurance +
      selectedGPOffer.GST;

    return { FOBSalePrice, ExportDuty, CIFSalePrice };
  };

  const handleMarginChange = (e) => {
    setMarginPercentage(e.target.value);
    setIsMarginChanged(true);
  };

  const redirectRequirement = () => {
    navigate("/global-partner/requirement");
  };
  //   const renderTabContent = () => {
  //     switch (activeTab) {
  //       default:
  //     }
  //   };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    menuActiveTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => handleMenuTabClick(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="row">
              <main className="main-content">
                <div className="offers-search row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <select
                      className="form-control form-select"
                      id="product"
                      name="product"
                      value={filterTerms.product || ""}
                      onChange={handleFilterChange}
                    >
                      <option value="">Select a product</option>
                      {[
                        ...new Set(
                          products.map((product) => product.ProductName)
                        ),
                      ].map((product) => (
                        <option key={product} value={product}>
                          {product}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <select
                      className="form-control form-select"
                      id="grade"
                      name="grade"
                      value={filterTerms.grade || ""}
                      onChange={handleFilterChange}
                    >
                      <option value="">Select a Grade</option>
                      {products
                        .filter(
                          (product) =>
                            product.ProductName === filterTerms.product
                        )
                        .map((product) => (
                          <option key={product.Grade} value={product.Grade}>
                            {product.Grade}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <select
                      className="form-control form-select"
                      id="state"
                      name="state"
                      value={filterTerms.state || ""}
                      onChange={handleFilterChange}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <button onClick={handleSearch} className="mx-3 d-inline">
                      Search
                    </button>
                    <button onClick={handleReset} className="d-inline">
                      Reset
                    </button>
                  </div>
                </div>

                <section className="offers">
                  <table>
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Grade</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Origin Country</th>
                        <th>Destination Country</th>
                        <th>INCO</th>
                        <th>Expires</th>
                        <th>Offer Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gpOffers.map((gpOffer) => (
                        <tr
                          key={gpOffer.GPOfferID}
                          onClick={() => handleRowClick(gpOffer)}
                          className={
                            selectedGPOffer &&
                            selectedGPOffer.GPOfferID === gpOffer.GPOfferID
                              ? "selected"
                              : ""
                          }
                        >
                          <td>{gpOffer.ProductName}</td>
                          <td>{gpOffer.Grade}</td>
                          <td>{gpOffer.Quantity}</td>
                          <td>{gpOffer.Price}</td>
                          <td>{gpOffer.OriginCountry}</td>
                          <td>{gpOffer.DestinationCountry}</td>
                          <td>{gpOffer.INCO}</td>
                          <td>{gpOffer.Expires}</td>
                          <td>{gpOffer.OfferType}</td>
                        </tr>
                      ))}
                      {gpOffers.length === 0 && (
                        <tr>
                          <td colSpan="7">No Offers available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="pagination">
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                      <button
                        key={index + 1}
                        onClick={() => handlePageChange(index + 1)}
                        className={currentPage === index + 1 ? "active" : ""}
                      >
                        {index + 1}
                      </button>
                    ))}
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </section>

                <section className="product-details">
                  <div className="tabs">
                    <button
                      className={activeTab === "basicInfo" ? "active" : ""}
                      onClick={() => handleTabClick("basicInfo")}
                    >
                      Basic Info
                    </button>
                    <button
                      className={activeTab === "specifications" ? "active" : ""}
                      onClick={() => handleTabClick("specifications")}
                    >
                      Specifications
                    </button>
                    <button
                      className={activeTab === "pricing" ? "active" : ""}
                      onClick={() => handleTabClick("pricing")}
                    >
                      Pricing
                    </button>
                    <button
                      className={activeTab === "breakup" ? "active" : ""}
                      onClick={() => handleTabClick("breakup")}
                    >
                      Breakup
                    </button>
                    <button
                      className={activeTab === "shipping" ? "active" : ""}
                      onClick={() => handleTabClick("shipping")}
                    >
                      Shipping
                    </button>
                    <button
                      className={activeTab === "queries" ? "active" : ""}
                      onClick={() => handleTabClick("queries")}
                    >
                      Queries
                    </button>
                  </div>

                  {activeTab === "basicInfo" && selectedGPOffer && (
                    <div className="tab-content active">
                      <div className="row">
                        <div className="col-lg-9 col-sm-9 col-6">
                          <div className="row">
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Product</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.ProductName}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Grade</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Grade}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Quantity</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Quantity}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Price</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Price}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>State</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.State}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Country</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Country}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>INCO</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.INCO}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Expires</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Expires}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-3 col-6">
                          <div className="actions">
                            <div className="row">
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleShortlist}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Shortlist
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleModify}
                                  disabled={!isMarginChanged}
                                  className={`form-control ${
                                    !isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Modify
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleApprove}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Approve
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleSendBAFO}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Send BAFO
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "specifications" && selectedGPOffer && (
                    <div className="tab-content active">
                      <div className="row">
                        <div className="col-lg-9 col-sm-9 col-6">
                          <div className="row">
                            <label htmlFor="productSpecifications">
                              Product Specifications
                            </label>
                            <textarea
                              id="productSpecifications"
                              name="productSpecifications"
                              className="form-control"
                              rows="10"
                              value={
                                selectedGPOffer.productSpecifications || ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-3 col-6">
                          <div className="actions">
                            <div className="row">
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleShortlist}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Shortlist
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleModify}
                                  disabled={!isMarginChanged}
                                  className={`form-control ${
                                    !isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Modify
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleApprove}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Approve
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleSendBAFO}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Send BAFO
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "pricing" && selectedGPOffer && (
                    <div className="tab-content active">
                      <div className="row">
                        <div className="col-lg-9 col-sm-9 col-6">
                          <div className="row">
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Currency</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Currency}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Price / MT</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Price}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Total Price</label>
                              <input
                                type="text"
                                readOnly
                                value={
                                  selectedGPOffer.Price *
                                  selectedGPOffer.Quantity
                                }
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Price Type</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.PriceType}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Payment</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.Payment}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-3 col-6">
                          <div className="actions">
                            <div className="row">
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleShortlist}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Shortlist
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleModify}
                                  disabled={!isMarginChanged}
                                  className={`form-control ${
                                    !isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Modify
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleApprove}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Approve
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleSendBAFO}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Send BAFO
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "breakup" && selectedGPOffer && (
                    <div className="tab-content active">
                      <div className="row">
                        <div className="col-lg-10 col-sm-9 col-12">
                          <div className="row">
                            <label>
                              Offer Pricing Breakup for Offer:{" "}
                              {selectedGPOffer?.ProductName} -{" "}
                              {selectedGPOffer?.Grade} -{" "}
                              {selectedGPOffer?.Quantity} MT -{" "}
                              {selectedGPOffer?.DestinationCountry}
                            </label>
                            <table class="datatable">
                              <tr class="dataheader">
                                <th colspan="1">Pricing Item</th>
                                <th rowspan="1">Pricing Component</th>
                                <th rowspan="1">Amount (Rs)</th>
                                <th rowspan="1">Amount (USD)</th>
                              </tr>
                              <tr class="primerow">
                                <td>Seller's Quantity (MT)</td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.Quantity)}
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr class="altrow">
                                <td>Seller's Price /MT (USD)</td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.Price)}
                                </td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr class="primerow">
                                <td>Seller's Total Price</td>
                                <td></td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.Quantity *
                                      selectedGPOffer?.Price
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.Quantity *
                                      selectedGPOffer?.Price *
                                      INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="altrow">
                                <td>AgroPreneur's Charges</td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.APCommissionPercentage
                                  )}
                                  %
                                </td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.APCommission)}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.APCommission * INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="primerow">
                                <td>Sorting & Grading Charges</td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.SortGradeChargedPercentage
                                  )}
                                  %
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.SortGradeCharged
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.SortGradeCharged * INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="altrow">
                                <td>Operations & Finance Charges</td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.OpsFinChargesPercentage
                                  )}
                                  %
                                </td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.OpsFinCharges)}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.OpsFinCharges * INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="primerow">
                                <td>Inland Transport Charges</td>
                                <td className="currency right">
                                  {selectedGPOffer?.InlandTransport
                                    ? formatData(
                                        selectedGPOffer?.InlandTransport /
                                          selectedGPOffer?.Quantity
                                      )
                                    : 0}
                                </td>
                                <td className="currency right">
                                  {selectedGPOffer?.InlandTransport
                                    ? formatData(
                                        selectedGPOffer?.InlandTransport
                                      )
                                    : 0}
                                </td>
                                <td className="currency right">
                                  {selectedGPOffer?.InlandTransport
                                    ? formatData(
                                        selectedGPOffer?.InlandTransport *
                                          INRToUsd
                                      )
                                    : 0}
                                </td>
                              </tr>
                              <tr class="primerow bold-font">
                                <td>Seller's BASE Price</td>
                                <td></td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.BasePrice)}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.BasePrice * INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="altrow">
                                <td>Margin (%)</td>
                                <td>
                                  <input
                                    type="text"
                                    value={marginPercentage}
                                    onChange={handleMarginChange}
                                    className="form-control"
                                    style={{
                                      width: "100px",
                                      float: "right",
                                      textAlign: "right",
                                    }}
                                  />
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    (selectedGPOffer?.BasePrice *
                                      marginPercentage) /
                                      100
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    ((selectedGPOffer?.BasePrice *
                                      marginPercentage) /
                                      100) *
                                      INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="primerow bold-font">
                                <td>FOB Sale Price</td>
                                <td></td>
                                <td className="currency right">
                                  {formatData(
                                    calculatePricingValues().FOBSalePrice
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    calculatePricingValues().FOBSalePrice *
                                      INRToUsd
                                  )}
                                </td>
                              </tr>
                              {/* <tr class="altrow">
                                <td>Export Duty</td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.ExportDutyPercentage
                                  )}
                                  %
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    calculatePricingValues().ExportDuty
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    calculatePricingValues().ExportDuty *
                                      INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="altrow">
                                <td>Shipping & Insurance</td>
                                <td className="currency right">
                                  Rs.{" "}
                                  {formatData(
                                    selectedGPOffer?.ShippingInsurancePercentage
                                  )}{" "}
                                  / MT
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.ShippingInsurance
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    selectedGPOffer?.ShippingInsurance *
                                      INRToUsd
                                  )}
                                </td>
                              </tr>
                              <tr class="altrow">
                                <td>GST (Local Taxes)</td>
                                <td></td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.GST)}
                                </td>
                                <td className="currency right">
                                  {formatData(selectedGPOffer?.GST * INRToUsd)}
                                </td>
                              </tr>
                              <tr class="primerow bold-font">
                                <td>CIF Sale Price</td>
                                <td></td>
                                <td className="currency right">
                                  {formatData(
                                    calculatePricingValues().CIFSalePrice
                                  )}
                                </td>
                                <td className="currency right">
                                  {formatData(
                                    calculatePricingValues().CIFSalePrice *
                                      INRToUsd
                                  )}
                                </td>
                              </tr> */}
                            </table>
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-3 col-12 d-flex flex-column align-items-end">
                          <div className="actions">
                            <div className="row">
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleShortlist}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Shortlist
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleModify}
                                  disabled={!isMarginChanged}
                                  className={`form-control ${
                                    !isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Modify
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleApprove}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Approve
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleSendBAFO}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Send BAFO
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "shipping" && selectedGPOffer && (
                    <div className="tab-content active">
                      <div className="row">
                        <div className="col-lg-9 col-sm-9 col-6">
                          <div className="row">
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Container Type</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.ContainerType}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Loading Port</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.LoadingPort}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Loading Date</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.LoadingDate}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Discharge Port</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.DischargePort}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Discharge Date</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.DischargeDate}
                                className="form-control"
                              />
                            </div>
                            <div className="col-lg-3 col-sm-4 col-6">
                              <label>Discharge Quantity</label>
                              <input
                                type="text"
                                readOnly
                                value={selectedGPOffer.DischargeQty}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-3 col-6">
                          <div className="actions">
                            <div className="row">
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleShortlist}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Shortlist
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleModify}
                                  disabled={!isMarginChanged}
                                  className={`form-control ${
                                    !isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Modify
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleApprove}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Approve
                                </button>
                              </div>
                              <div className="col-12 mb-2">
                                <button
                                  onClick={handleSendBAFO}
                                  disabled={isMarginChanged}
                                  className={`form-control ${
                                    isMarginChanged ? "disabled-button" : ""
                                  }`}
                                >
                                  Send BAFO
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "queries" && (
                    <div className="tab-content active">
                      <div className="row">
                        <div className="col-lg-10 col-sm-9 col-12">
                          <table>
                            <thead>
                              <tr>
                                <th>Query Date</th>
                                <th>Query</th>
                                <th>Reply Date</th>
                                <th>Reply</th>
                              </tr>
                            </thead>
                            <tbody>
                              {queries.map((query) => (
                                <tr
                                  key={query.QueryID}
                                  onClick={() => handleQueryRowClick(query)}
                                  className={
                                    selectedQuery &&
                                    selectedQuery.QueryID === query.QueryID
                                      ? "selected"
                                      : ""
                                  }
                                >
                                  <td>{query.QueryDate}</td>
                                  <td>{query.QueryDescription}</td>
                                  <td>{query.QueryReplyDate}</td>
                                  <td>{query.QueryReply}</td>
                                </tr>
                              ))}
                              {queries.length === 0 && (
                                <tr>
                                  <td colSpan="4">No queries available</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-lg-2 col-sm-3 col-12">
                          <div className="actions">
                            <button
                              disabled={
                                selectedGPOffer === undefined ||
                                selectedGPOffer === null
                              }
                              onClick={() => {
                                setShowRaiseQueryModal(true);
                              }}
                            >
                              Raise Query
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="pagination">
                        <button
                          onClick={() => handleQueryPageChange(queryPage - 1)}
                          disabled={queryPage === 1}
                        >
                          {"<"}
                        </button>
                        {Array.from({ length: queryTotalPages }, (_, index) => (
                          <button
                            key={index + 1}
                            onClick={() => handleQueryPageChange(index + 1)}
                            className={queryPage === index + 1 ? "active" : ""}
                          >
                            {index + 1}
                          </button>
                        ))}
                        <button
                          onClick={() => handleQueryPageChange(queryPage + 1)}
                          disabled={queryPage === queryTotalPages}
                        >
                          {">"}
                        </button>
                      </div>
                    </div>
                  )}
                </section>
              </main>
            </div>
          </main>
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>{showModalMsg}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRaiseQueryModal}
        onHide={() => setShowRaiseQueryModal(false)}
        backdrop="static"
        className="modal-raisequery"
      >
        <Modal.Header closeButton>
          <Modal.Title>Raise Query</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <textarea
                placeholder="Enter Query Description"
                className="form-control mb-2"
                value={queryDescription}
                onChange={(e) => setQueryDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCreateQuery}>
            Raise Query
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowRaiseQueryModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSelectBuyerModal}
        onHide={() => setShowSelectBuyerModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Buyer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label>Select Buyer:</label>
            <select
              className="form-control"
              value={selectedBuyer}
              onChange={(e) => {
                setSelectedBuyer(e.target.value);
              }}
            >
              <option value="" disabled>
                Select a buyer
              </option>
              {buyers.map((buyer) => (
                <option
                  key={buyer.EmailID}
                  value={buyer.EmailID}
                >{`${buyer.FirstName} ${buyer.LastName} <${buyer.EmailID}>`}</option>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSelectBuyerModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSelectBuyer}
            disabled={selectedBuyer === ""}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GPOffersOld;
